import { AppRouterLimited } from "../shared/components/AppRouter";

import { routes, routesLimited } from "./routes";

export const ParticipantRoutes = () => (
  <AppRouterLimited routes={routes} routesLimited={routesLimited} />
);
